import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/auth/useAuth';
import Loading from '../Loading/Loading';
import { HOME, ADMIN_PRODUCTS, ADD_PRODUCT } from '../../lib/routes';
/* import Orders from './Sales/Orders'; */
import { motion } from 'framer-motion';
import { FiBox, FiPlus, FiShoppingBag } from 'react-icons/fi';
import { Outlet } from "react-router-dom";

const AdminIndex = () => {
  const navigate = useNavigate();
  const { user, userData, isLoading } = useAuth();

  useEffect(() => {
    if (!isLoading && (!user || !userData || userData.access_level !== 'admin')) {
      navigate(HOME);
    }
  }, [user, userData, isLoading, navigate]);

  if (isLoading || !userData) return <Loading />;

  const tiles = [
    {
      title: 'Add Product',
      icon: <FiPlus className="text-3xl text-purple-600" />,
      route: ADD_PRODUCT,
    },
    {
      title: 'View Products',
      icon: <FiBox className="text-3xl text-blue-600" />,
      route: ADMIN_PRODUCTS,
    },
    {
      title: 'View Orders',
      icon: <FiShoppingBag className="text-3xl text-green-600" />,
      route: '/protected/orders', // optional route if you want a separate page
    },
  ];

  return (
    <div className="min-h-screen bg-gray-100 py-10 px-6">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-extrabold text-gray-800 mb-10">
          🛠 Admin Dashboard
        </h1>

        {/* Dashboard Tiles */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mb-12">
          {tiles.map((tile) => (
            <motion.div
              key={tile.route}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.97 }}
              className="bg-white rounded-xl shadow-md p-6 cursor-pointer hover:shadow-lg transition"
              onClick={() => navigate(tile.route)}
            >
              <div className="flex flex-col items-center justify-center h-full text-center">
                {tile.icon}
                <h2 className="text-xl font-semibold mt-3 text-gray-800">{tile.title}</h2>
              </div>
            </motion.div>
          ))}
        </div>
        <Outlet />
      </div>
    </div>
  );
};

export default AdminIndex;
